export default {
  EMPTY: 'empty',
  LOADING: 'loading',
  LOADED: 200,
  ERROR: 'error'
};
